import { useCallback, useSyncExternalStore } from 'react';

// Lightweight global pub-sub for the current page title. Pages call
// `useSetPageTitle()` to publish; the topbar widget reads via `usePageTitle()`.

let currentTitle = '';
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((fn) => fn());

export const setPageTitle = (title: string) => {
  if (title !== currentTitle) {
    currentTitle = title;
    notify();
  }
};

export const clearPageTitle = () => setPageTitle('');

export const usePageTitle = () =>
  useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => currentTitle,
    () => currentTitle,
  );

export const useSetPageTitle = () => useCallback((title: string) => setPageTitle(title), []);
